/**
 * @generated SignedSource<<b2795bd1f18f92155cb39fba1df2880e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedSkinnyBannerModule_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly messages: {
    readonly cta: string | null;
    readonly imageCopy: string | null;
    readonly imageHeight?: string | null;
    readonly imageUrl?: string | null;
    readonly imageWidth?: string | null;
    readonly isFullBleedImage: boolean | null;
    readonly linkData: {
      readonly path: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly mobileImageHeight?: string | null;
    readonly mobileImageUrl?: string | null;
    readonly mobileImageWidth?: string | null;
  } | null;
  readonly " $fragmentType": "HpSharedSkinnyBannerModule_componentModule";
};
export type HpSharedSkinnyBannerModule_componentModule$key = {
  readonly " $data"?: HpSharedSkinnyBannerModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedSkinnyBannerModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedSkinnyBannerModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "SkinnyBannerModuleItemMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "condition": "isMobile",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageWidth",
              "storageKey": null
            }
          ]
        },
        {
          "condition": "isMobile",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileImageHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileImageWidth",
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cta",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageCopy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFullBleedImage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SkinnyBannerModule",
  "abstractKey": null
};

(node as any).hash = "7e1021c23db1469a709cd6726608ebcc";

export default node;
